module.exports = __webpack_public_path__ + "img/3.dc865a06.png";